import React from 'react'

function Footer() {
  let date =  new Date().getFullYear()
  
  function scrollUp() {
    document.getElementById(`main-content`).scrollTo(0, 0)
  }
  
  return (
    <footer>
      <div id="footer-copyright" style={{display: "flex"}}>
        <p>Copyright &copy; {date} WithLeast</p>
      </div>
      <button id="scroll-up" onClick={scrollUp}>Scroll Up</button>
    </footer>
  )
}

export default Footer